module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-shadow box-shadow--big"
  }, [_c('div', {
    staticClass: "helper__wrapper"
  }, [_c('div', {
    staticClass: "flex-row flex-start"
  }, [_c('label', {
    staticClass: "fake-label row3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q8_1_typeVal),
      expression: "s3q8_1_typeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "TORBIEL",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q8_1_typeVal, "TORBIEL")
    },
    on: {
      "change": [function($event) {
        _vm.s3q8_1_typeVal = "TORBIEL"
      }, function($event) {
        return _vm.updateType(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('CYSTS')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label row3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q8_1_typeVal),
      expression: "s3q8_1_typeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "WLOKNIAK",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q8_1_typeVal, "WLOKNIAK")
    },
    on: {
      "change": [function($event) {
        _vm.s3q8_1_typeVal = "WLOKNIAK"
      }, function($event) {
        return _vm.updateType(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container small",
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_vm._v(_vm._s(_vm.$t('FIBROMA')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label row3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q8_1_typeVal),
      expression: "s3q8_1_typeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "BRODAWCZAK",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q8_1_typeVal, "BRODAWCZAK")
    },
    on: {
      "change": [function($event) {
        _vm.s3q8_1_typeVal = "BRODAWCZAK"
      }, function($event) {
        return _vm.updateType(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('PAPILLOMA')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label row3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q8_1_typeVal),
      expression: "s3q8_1_typeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "MASTOPATYCZNA",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q8_1_typeVal, "MASTOPATYCZNA")
    },
    on: {
      "change": [function($event) {
        _vm.s3q8_1_typeVal = "MASTOPATYCZNA"
      }, function($event) {
        return _vm.updateType(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('MASTHOPATIC_CHANGES')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-column"
  }, [_c('label', {
    staticClass: "fake-label row3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q8_1_typeVal),
      expression: "s3q8_1_typeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "INNA",
      "name": "right-breast-changes"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q8_1_typeVal, "INNA")
    },
    on: {
      "change": [function($event) {
        _vm.s3q8_1_typeVal = "INNA"
      }, function($event) {
        return _vm.updateType(true)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('OTHER_WHAT')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), (_vm.showValueInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q8_1_typeDescription),
      expression: "s3q8_1_typeDescription"
    }],
    staticClass: "el-input__inner el-input__inner--small row3",
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "placeholder": _vm.$t('INSERT_CHANGE'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.s3q8_1_typeDescription)
    },
    on: {
      "change": _vm.updateDescription,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s3q8_1_typeDescription = $event.target.value
      }
    }
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eb11b8c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/helpers/right-breast-changes-diagnostic.vue
// module id = 1208
// module chunks = 0